import { z } from "zod";
import { CHECKLIST, SAFETY_CHECKLIST } from "./consts";

export const schema = z.object({
  [CHECKLIST]: z.any().optional(),
  [SAFETY_CHECKLIST]: z.array(z.string()).min(1, "This Field is required."),
});

export type formValues = z.infer<typeof schema>;
